<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file EventQuickBuy.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  EventQuickBuy.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: EventQuickBuy
 Description: Displays a list of 4 events with the first 3 tickets available to quickly add to basket
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2019-03-21
 Time: 09:28
------------------------------------------------------------------------------->
<template>
    <section>
        <div class="container mb-3">
            <div class="row">
                <div class="col-12">
                    <BundleSeasonTickets
                            :addons="addons"
                            :tickets="createSeasonTicketBundles"
                            :add_ticket_url="add_ticket_url"
                            @ticket_clicked="requestTicket"
                    />
                </div>
            </div>
        </div>

        <div v-if="tile_across" class="row" data-ref="tile_across">
            <div v-for="(event_item,index) in events"
                 :class="[
                 tile_class,
                 {
                            'col-md-12':index === last && mod === 3
                        }
                 ]"
            >
                <tileCard
                        :add_ticket_url="add_ticket_url"
                        class="mb-5 mb-md-0"
                        :record="event_item"
                        :records="events"
                        element_type="article"
                        :tickets="setTickets(event_item)"
                        @ticket_clicked="requestTicket"
                        @addons_updated="addonsUpdated"
                />
            </div>
        </div>
        <div v-else class="container">
            <template v-for="(event_item,index) in events">
                <TileCardHorizontal
                        :tickets_limit="tickets_limit"
                        :add_ticket_url="add_ticket_url"
                        class="mb-5"
                        :record="event_item"
                        :records="events"
                        element_type="article"
                        :tickets="setTickets(event_item)"
                        @ticket_clicked="requestTicket"
                        @addons_updated="addonsUpdated"
                />
            </template>
        </div>
    </section>
</template>

<script>
    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {_} from 'underscore';
    import axios from 'axios';
    import BasketTickets from '../basket/BasketTickets.js';
    import BasketToastr from '../basket/BasketToastr.js';
    import {_ as us} from 'underscore';
    window.Vue.component('tileCard', require('../front/modules/tileCard'));
    window.Vue.component('BundleSeasonTickets', require('./BundleSeasonTickets.vue'));
    window.Vue.component('TileCardHorizontal', require('../front/modules/TileCardHorizontal.vue'));

    export default {
        name: "event-quick-buy",
        components: {},
        props: {
            url: String,
            add_ticket_url: String,
            season_bundles: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            quick_events: {
                type: Array,
                default: null
            },
            tile_across: {
                type: Boolean,
                default: true
            },
            tickets_limit: {
                type: Number,
                default: 6
            }
        },
        mixins: [BasketTickets, BasketToastr],
        created() {
        },
        destroyed() {
        },
        mounted() {
            if (this.quick_events !== null) {
                this.events = this.quick_events;
                this.processEvents();
            } else {
                this.readEvents();
            }
        },
        data() {
            return {
                addons: {},
                events: [],
                tickets: {},
                bundle_tickets: [],
                debugging: false,
                tickets_clicked: [],
                toastr_last: {},
                toastr_options: {
                    newestOnTop: true,
                    progressBar: true,
                    timeOut: 6000,
                    positionClass: "toast-top-right",
                    showMethod: 'slideDown',
                    hideMethod: 'slideUp',
                    showDuration: "150",
                },
                tile_class: 'col-12 col-md-6 col-lg-3',
                limit: 4,
                mod: 0
            }
        },
        methods: {
            addonsUpdated(addons){
            //     let self = this;
            //
            //     console.log('addons',typeof addons,addons)
            //     for(let i in addons){
            //         let addon = addons[i];
            //         let addonId = addon.id;
            //         let found = us.findWhere(self.addons,function(record){
            //             return record.id === addonId
            //         });
            //         if(typeof found === 'undefined' ){
            //             this.addons = addons;
            //             break;
            //         }
            //
            //         // if(!found){
            //         //     this.addons.push(addon)
            //         // }
            //         // console.log('addon',typeof addon, addon,addonId)
            //         //
            //         // console.log('found',found)
            //     }
            //     // this.addons = addons;
            },
            log(...args) {
                // console.log(...args);
            },
            setTickets(record) {
                let self = this;

                let tickets = [];

                for (let ticketsKey in record.tickets) {
                    /**
                     * @param ticket.allocated
                     * @param ticket.sale_content_counter_count
                     * @param ticket.ticket_data
                     * @namespace ticket
                     */
                    let ticket = record.tickets[ticketsKey];
                    if (ticket.status === 'active') {
                        tickets.push(self.createTicketRecord(ticket))
                    }
                }
                return tickets;
            },
            createTicketRecord(ticket) {
                let self = this;
                let compiledTicket = {
                    id: ticket.id,
                    icon: ticket.entity.icon,
                    title: lang('title', ticket.ticket_data.lang),
                    price: parseFloat(ticket.price / 100),
                    sold_out: this.isSoldOut(ticket),
                    allocated: ticket.allocated,
                    reserved_tickets_count: ticket.reserved_tickets_count,
                    sale_content_counter_count: ticket.sale_content_counter_count,
                    show: false,
                    ticket_type: ticket.ticket_type,
                    description_short: lang('description.short', ticket.ticket_data.lang),
                    description_long: lang('description.long', ticket.ticket_data.lang),
                    attributes: ticket.ticket_data.attributes
                };

                compiledTicket[this.is_bundle(ticket) ? 'bundle' : 'entity'] = {
                    images: self.findDataImage(ticket),
                    title: self.findDataLang(ticket, 'title'),
                    description_short: self.findDataLang(ticket, 'description.short'),
                    description_long: self.findDataLang(ticket, 'description.long')
                };

                return compiledTicket;
            },
            is_bundle(ticket) {
                return ticket.is_bundle > 0
            },
            findDataImage(ticket) {
                if (this.is_bundle(ticket)) {
                    return ticket.ticket_data.bundle.images
                } else {
                    return ticket.entity.images
                }
            },
            findDataLang(ticket, target) {
                if (this.is_bundle(ticket)) {
                    return this.findBundleLang(ticket, target)
                } else {
                    return this.findEntityLang(ticket, target)
                }
            },
            findBundleLang(ticket, target) {
                return lang(target, ticket.ticket_data.bundle.lang);
            },
            findEntityLang(ticket, target) {
                if (typeof ticket.entity.lang !== 'undefined' && ticket.entity.lang !== 'null') {
                    return lang(target, ticket.entity.lang)
                } else if (typeof ticket.entity.entity_data.lang !== 'undefined' && ticket.entity.entity_data.lang !== 'null') {
                    return lang(target, ticket.entity.entity_data.lang)
                }
                return null;
            },
            // showToastr(type, params) {
            //     let self = this,
            //         title = ('title' in params) ? `<div>${params.title}</div>` : '',
            //         message = `<div class="p-3">${params.message}</div>`
            //     ;
            //     if (self.debugging) {
            //         self.toastr_options.progressBar = false;
            //         self.toastr_options.timeOut = false;
            //     }
            //
            //     toastr.options = self.toastr_options;
            //
            //     self.toastr_last = toastr[type](
            //         `${title}
            //         ${message}`
            //     );
            // },
            readEvents() {
                let self = this;

                let data = {};

                axios.get(this.url, data)
                    .then(function (response) {
                        self.events = response.data;
                        self.processEvents();

                    })
                    .catch(function (e) {
                        console.error('events fetch', e);
                    });
            },
            processEvents() {
                let self = this;

                self.mod = self.events.length % this.limit;
                switch (self.mod) {
                    case 3:
                        self.tile_class = 'col-12 col-md-6 col-lg-4';
                        break;
                    case 2:
                        self.tile_class = 'col-12 col-md-6 col-lg-6';
                        break;
                    case 1:
                        self.tile_class = 'col-12 col-md-6 col-lg-6';
                        break;
                    default:
                        self.tile_class = 'col-12 col-md-6 col-lg-6 col-xl-3';
                        break;
                }

                for (let eventsKey in self.events) {
                    let event = self.events[eventsKey];

                    for (let ticketsKey in event.tickets) {
                        let ticket = event.tickets[ticketsKey];
                        if (ticket.status === 'active') {
                            self.tickets[ticket.id] = ticket;
                        }
                    }
                }
            },
            requestTicket(x) {

                let self = this;
                let ticket = [];
                if (typeof x === 'number') {
                    ticket = this.tickets[x];
                } else {
                    ticket = this.season_bundles[x.id];
                }


                let index = _.indexOf(self.tickets_clicked, ticket.id);

                // the item has already been requested and not yet returned a confirmation
                if (index >= 0) {
                    self.showToastr('warning', {message: 'please wait while we get your ticket'});
                    return false;
                } else {
                    if (self.isSoldOut(ticket) === true) {
                        self.showToastr('warning', {message: 'Ticket sold out'});
                        self.tickets_clicked = self.removeTicketFromWaitingList(ticket.id);
                        return false;
                    } else {
                        self.showToastr('info', {message: 'checking for available tickets'});

                        self.addTicketToBasket(ticket)
                            .then(function (response) {
                                // console.log('response',response.data.sold_out)
                                /**
                                 * @param {Boolean} response.data.sold_out
                                 * @param {Boolean} response.data.exceeded
                                 * @param {Object} response.data
                                 * @namespace {Object} response
                                 * */
                                if (response.data.sold_out === true) {
                                    // console.log('sold out');
                                    toastr.clear(self.toastr_last);
                                    self.tickets_clicked = self.removeTicketFromWaitingList(ticket.id);
                                    self.showToastr('warning', {message: 'this ticket is sold out'});
                                } else if (response.data.exceeded === true) {
                                    let maxNumberOfTickets = response.data.limit;

                                    toastr.clear(self.toastr_last);
                                    self.tickets_clicked = self.removeTicketFromWaitingList(ticket.id);
                                    self.showToastr('warning', {message: 'Only ' + maxNumberOfTickets + ' per purchase'});
                                } else {
                                    self.setAnimationComponent(ticket, function (animate_element) {
                                        animate_element.element.removeChild(animate_element.clone);
                                        // remove reserve from ticket adding process
                                        self.tickets_clicked = self.removeTicketFromWaitingList(ticket.id);
                                        // window.modalBasketVue.$children[0].readBasket();
                                        self.$basketController.$emit('read_basket', ticket.id);
                                        toastr.clear();
                                    });
                                }
                            });
                    }
                }
            },
            async addTicketToBasket(ticket, callback) {
                let data = {};
                this.tickets_clicked.push(ticket.id);

                return await axios.post(`${this.add_ticket_url}/${ticket.id}`, data)
                    .then(function (response) {
                        return response;
                    })
                    .catch(function (e) {
                    });
            },
            removeTicketFromWaitingList(ticket_id) {
                let self = this,
                    index = _.indexOf(self.tickets_clicked, ticket_id);

                if (index > -1) {
                    self.$delete(self.tickets_clicked, index);
                }

                return self.tickets_clicked;
            },
            setAnimationComponent(ticket, callback) {
                let self = this,
                    transition = 600,
                    elementId = `ticket-selection--${ticket.id}`,
                    element = document.getElementById(elementId),

                    /**
                     * @param clone.widget
                     * @param clone.style
                     * @param clone.id
                     * @type {Node} clone
                     */
                    clone = element.cloneNode(true);

                element.style.position = 'relative';

                clone.id = elementId + '--clone';
                clone.style.position = 'absolute';
                clone.style.zIndex = 9999999999;
                clone.style.opacity = 0.5;
                clone.widget = element.width;
                clone.style.backgroundColor = 'white';
                clone.style.transition = `transform ${transition}ms  ease-out, opacity ${transition}ms  ease-out`;

                let ticketReference = document.getElementById(elementId);

                // create the clone behind the original
                ticketReference.appendChild(clone);

                let basketElm = document.getElementById('basket-modal-wrapper-trigger'),
                    bodyRect = document.body.getBoundingClientRect(),
                    targetPosRight = document.body.clientWidth,
                    elementRect = element.getBoundingClientRect(),
                    cloneTopPosition = elementRect.top - bodyRect.top,
                    relativeTop = cloneTopPosition - self.offset(basketElm).top;

                clone.style.opacity = 0;
                clone.style.transform = `translate(${targetPosRight}px,${relativeTop * -1}px)`;

                return callback({
                    clone: clone,
                    element: element,
                    transition: transition
                });
            },
            offset(el) {
                let rect = el.getBoundingClientRect(),
                    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
            }
        },
        watch: {},
        computed: {
            last() {
                return Object.keys(this.events).length - 1;
            },
            createSeasonTicketBundles() {
                let tickets = [];
                for (let ticketId in this.season_bundles) {
                    let ticket = this.season_bundles[ticketId];
                    tickets.push(this.createTicketRecord(ticket));
                }
                this.bundle_tickets = tickets;
                return tickets;
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/layouts/EventQuickBuy.vue